<template>
  <div id="pages">
    <App v-if="!videoSubtitle"></App>
    <AppSubtitle v-if="!videoSubtitle && openSubtitle"></AppSubtitle>
    <VideoSubtitle v-if="$route.subtitle"></VideoSubtitle>
    <!-- <PayDialog
      v-model="payDialogVisible"
      v-bind="payDialogProps"
    ></PayDialog> -->
    <pagePopupsLayer></pagePopupsLayer>
  </div>
</template>

<script>
import App from "./App";
import AppSubtitle from "./AppSubtitle";
import VideoSubtitle from "./VideoSubtitle";
import subtitleUI from "../static/animengine/js/subtitle/subtitleUI";
import pagePopupsLayer from './components/pagePopups/pagePopupsLayer.vue';
import presentationLayer from './components/draftPreview/presentationLayer.vue';
import { mapGetters, mapActions } from "vuex";
import {
  getUserVideoInfo,
  getVideoCodeInfo
} from "./components/subtitle/subtitleApi";

export default {
  data () {
    return {
      resetLeftMask: null,
      resetRightMask: null,
      videoSubtitle: true,
      videoFileType: "26",
      videoId: "",
    };
  },
  created () {
    this.$bus.on('vipPaying.showDialog', ({visible, props}) => {
      this.$store.commit('vipPaying/setComponentProps', props);
      console.log(`Turbo ~ this.$bus.on ~ props`, props)
      this.$store.commit('vipPaying/setDialogVisible', visible);
    })
  },
  mounted () {
    var seg = window.location.href.split("/");
    this.videoId = seg[seg.length - 1];
    this.videoSubtitle = this.$route.subtitle;
    this.videoFileType = this.$route.filetype || this.$route.fileType || "26";

    //this.$route.
    //http://localhost:8080/tool#/b6888847-4fce-430c-9ce9-eb8b7bdf3b55
    //console.log('this.$route', window.location.pathname.startsWith('/subtitle/'))
    //e152d7b2-17c7-4b07-98b3-8568b67739ef
    //be408edb-e6ea-4e7d-abb4-4a18f5e8f816
    //http://localhost:8080/tool?subtitle=true&filetype=26/be408edb-e6ea-4e7d-abb4-4a18f5e8f816
    if (this.videoSubtitle) {
      this.getVideoInfo(this.videoId, this.videoFileType).then((t) => {
        t.type = "video";
        this.$store.commit("subtitle/setSubtitleObj", t);
        let subtitleEditor = new subtitleUI(t);
        this.$store.commit("subtitle/setSubtitleEditor", subtitleEditor);
        subtitleEditor.loadUI();
        subtitleEditor.stop(0);
        this.$bus.emit('subtitle_fromJson');
      });
    } else {
      let subtitleEditor = new subtitleUI();
      this.$store.commit("subtitle/setSubtitleEditor", subtitleEditor);
    }
  },
  computed: {
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
      MaterialPane_Size: "MaterialPane_Size",
      SetPanel_Size: "SetPanel_Size",
      subtitleObj: "subtitle/subtitleObj",
      subtitleEditor: "subtitle/subtitleEditor",
      payDialogProps: 'vipPaying/componentProps'
    }),
    ...mapGetters(["Tool_Size", "TopNav_Size", "MaterialPane_Size", "TOOL"]),
    payDialogVisible: {
      get () {
        console.log(`Turbo ~ get ~ this.$store`, this.$store)
        return this.$store.getters['vipPaying/dialogVisible'];
      },
      set (val) {
        this.$store.commit('vipPaying/setDialogVisible', val);
      }
    }
  },
  watch: {
    openSubtitle: function (val) {
      if (val) {
        this.$store.commit("toggle_shortcutType", "subtitle");
        this.retainSize();
        this.hidePanel();
        $('.Tool .scroll-content').css({overflow: 'hidden'});
      } else {
        this.$store.commit("toggle_shortcutType", "editor");
        $('.Tool .scroll-content').css({overflow: 'scroll'});
        // let toolElem = document.querySelector('#app > .Tool');
        // toolElem.style.display = 'block';
        this.resetPanel();
      }
    },
    // 'TOOL.fixLeft' () {
    //   if (this.openSubtitle) {
    //     this.hidePanel();
    //   }
    // }
  },
  components: {
    App,
    AppSubtitle,
    VideoSubtitle,
    pagePopupsLayer,
    presentationLayer
  },

  methods: {
    retainSize() {
      this.oldLeft = this.MaterialPane_Size.width;
      this.oldRight = this.SetPanel_Size.width;
    },
    hidePanel () {
      const panelWidth = (document.documentElement.scrollWidth - this.TOOL.clientWidth - 246) / 2 - this.TOOL.fixLeft;
      this.resetLeftMask = { ...this.MaterialPane_Size };
      this.resetRightMask = { ...this.SetPanel_Size };
      this.$store.commit("save_SetPanel", { width: panelWidth });
      this.$store.commit("save_MaterialPane", { width: panelWidth });
      this.$bus.emit("EditorSetOption_vue", {
        data: true,
        source: "subtitle"
      });
    },
    resetPanel () {
      this.$store.commit("save_MaterialPane", { ...this.resetLeftMask, width: this.oldLeft });
      this.$store.commit("save_SetPanel", { ...this.resetRightMask, width: this.oldRight });
      this.$store.commit('save_Window', {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      });
      this.$bus.emit('EditorSetOption_vue', {
        data: true,
        source: 'app',
      });
    },
    setCanvasSize () {
      // this.TOOL.setOption({
      //   width: this.Tool_Size.width,
      //   height: this.Tool_Size.height - 40,
      //   surplusY: this.TopNav_Size.height + 40,
      //   surplusX: this.MaterialPane_Size.width,
      // });

      // this.subtitleEditor.setOption({
      //   width: this.TOOL.clientWidth,
      //   height: this.TOOL.clientHeight
      // });
      this.$bus.emit('subtitle.setCanvasSize');
    },
    setCanvasSizeDelay () {
      clearTimeout(this.tid || 0);
      this.tid = setTimeout(this.setCanvasSize, 0);
    },
    async getVideoInfo (id, fileType) {
      let res = await getUserVideoInfo(id, fileType);
      if (!res) return null;
      if (res.caption && res.caption != '{}') {
        let videoCodeInfo = await getVideoCodeInfo(res.url);
        let captionObj = JSON.parse(res.caption);
        if (!captionObj.url) {
          captionObj.url = res.url;
        }
        if (videoCodeInfo.duration) {
          captionObj.duration = videoCodeInfo.duration;
        }
        captionObj.id = id;
        return handleInfo(captionObj);
      } else if (res.url) {
        let videoCodeInfo = await getVideoCodeInfo(res.url);
        let videoInfo = {
          id: res.id, //项目或者视频的id
          title: res.title,
          duration: videoCodeInfo.duration || res.duration || res.during,
          url: res.url,
          type: "video", //字幕类型：draft/video
          optimized: "Horizontal",
          productionPlatform: "web",
          resolution: {
            height: videoCodeInfo.height,
            width: videoCodeInfo.width,
          },
          contents: []
        };

        return handleInfo(videoInfo)
      }

      function handleInfo (videoInfo) {
        if (videoInfo.coordinate && videoInfo.coordinate.width > 0) {
          return videoInfo;
        }
        let x = 0,
          y = 0,
          width = videoInfo.resolution.width,
          height = videoInfo.resolution.height;
        let scale = Math.floor((width / height) * 100000) / 100000;
        let contrastScale = Math.floor((16 / 9) * 100000) / 100000;
        if (scale > contrastScale) {
          width = 1920;
          height = width / scale;
        } else if (scale < contrastScale) {
          height = 1080;
          width = height * scale;
        } else {
          width = 1920;
          height = 1080;
        }
        x = (1920 - width) / 2;
        y = (1080 - height) / 2;
        videoInfo.coordinate = {
          x: x,
          y: y,
          width: width,
          height: height
        };
        return videoInfo;
      }
    },
  },
};
</script>

<style lang="scss">
@mixin ff() {
  font-family: 'Microsoft Yahei', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'WenQuanYi Micro Hei', sans-serif;
}

#pages {
  position: relative;
  z-index: 2001;
  overflow: hidden;
  width: 100%;
  height: 100%;
  font-family: 'Microsoft Yahei', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'WenQuanYi Micro Hei', sans-serif;
  font-size: 14px;
  text-align: center;
  background: #f0f0f8;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  input,
  textarea {
    @include ff();
    outline: none;
  }
}
html,
body {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  min-height: 768px;
  padding: 0;
  margin: 0;
}
@media (min-width: 768px) and (max-width: 1024px) {
  html {
    overflow-y: scroll;
  }
  body {
    overflow-y: hidden;
  }
}
@media screen and (max-width: 1366px) {
html,
body {
  min-height: 680px;
}
}
* {
  user-select: none !important;
}
</style>



// WEBPACK FOOTER //
// src/Page.vue